import Sidebox from "./layouts/sidebox";
import Settings from "./layouts/settings";
import { EventConstants } from "AC/constants";
AdminColumns.events.addListener(EventConstants.SETTINGS.FORM.READY, function (form) {
    var layouts = document.querySelector('.sidebox.layouts');
    if (layouts) {
        AdminColumns.OrderSidebox = new Sidebox(layouts);
        // Order the Column sets menu
        var list_1 = document.querySelector('.layout-selector ul');
        if (list_1) {
            AdminColumns.OrderSidebox.onOrdered(function (order) {
                var temp = document.createElement('div');
                order.forEach(function (key) {
                    var item = list_1.querySelector("[data-screen=\"" + key + "\"]");
                    if (item) {
                        temp.appendChild(item);
                    }
                });
                temp.querySelectorAll('li').forEach(function (el) {
                    list_1.appendChild(el);
                });
            });
        }
    }
    var settings = document.querySelector('.ac-setbox');
    if (settings) {
        AdminColumns.ListScreenSettings = new Settings(document.querySelector('.ac-setbox'), form);
    }
    var title = document.querySelector('#listscreen_settings input[name="title"]');
    if (title) {
        title.addEventListener('keyup', function () {
            document.querySelectorAll(".layout-selector [data-screen=\"" + AC.layout + "\"] a").forEach(function (el) {
                el.innerHTML = title.value;
            });
            document.querySelectorAll(".layouts__items [data-screen=\"" + AC.layout + "\"] [data-label]").forEach(function (el) {
                el.innerHTML = title.value;
            });
        });
    }
});
